import NavigationBar from "../../../navigation_components/NavigationBar";
import SystemAdministratorSideBar from "../../../sidebar_components/SystemAdministratorSideBar";
import "../../../../styles/workspace_styles/SystemAdministratorStyles/HomePage/HomePage.css";

const HomePage = () =>{
    return(
        <div className="system-administrator-home-page">
            <NavigationBar/>
            <div className="system-administrator-home-page-layout">
                <div>
                    <SystemAdministratorSideBar/>
                </div>
                <div className="system-administrator-home-page-parent-container">
                    <div>
                        <p>System administrator Home Page coming soon</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HomePage;